/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfo, FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfoFromJSONTyped, FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfoToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfo';
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfo(json)) {
        return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfoFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoToJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfo(value)) {
        return FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultCardInfoToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfo.js.map